import {BaseContainerModel} from "../../../base-container.model";
import {
  bl_alg_cc_agent_vc_squad_contact_link_RowClass,
  bl_alg_cc_agent_vc_squad_contact_link_RowInterface
} from "../../../../dbschema";

export class AgentVirtualContactSquadContactContainerModel extends BaseContainerModel {
  bl_alg_cc_agent_vc_squad_contact_link: bl_alg_cc_agent_vc_squad_contact_link_RowInterface = new bl_alg_cc_agent_vc_squad_contact_link_RowClass();
}
